// Validation messages extracted from ro.js to avoid circular dependency
export const validationMessages = {
  messages: {
    required: 'Câmpul {field} este obligatoriu.',
    email: 'Câmpul {field} trebuie să fie un e-mail valid.',
    password: 'Parola trebuie să conțină cel puțin 8 caractere, o literă mare, o literă mică și un număr.',
    phone: 'Numărul de telefon trebuie să fie valid.',
    iban: 'IBAN-ul trebuie să fie valid.',
    name: 'Doar literele fără diacritice sunt acceptate.',
    terms: 'Trebuie să fii de acord cu termenii și condițiile.',
  },
  names: {
    name: 'Prenume',
    surname: 'Nume',
    email: 'E-mail',
    password: 'Parolă',
    phone: 'Telefon',
    iban: 'IBAN',
    country: 'Țară',
    address: 'Adresă',
    city: 'Oraș',
    zip: 'Cod poștal',
    agreement: 'Acord',
    terms: 'Termeni și condiții',
    retailer: 'Magazin',
    campaignStep: 'Pasul campaniei',
    receiptDate: 'Data bonului',
    receiptNumber: 'Numărul bonului',
    receiptAmount: 'Suma bonului',
    receiptProduct: 'Produsul de pe bon'
  }
}
